export interface PatientCDOModel {
  org: string;
  id: string;
  firstName: string[];
  lastName: string[];
  middleName: string[];
  dob: string;
  age: number;
  gender: string;
  genderPrefix: string;
  homePhone: string[];
  mobilePhone: string[];
  email: string[];
  memberId: string[];
  otherId: string[];
  /** Payor person id from `https://projectwell.io/fhir/identifiers/person-id` (ingestion). */
  personId: string[];
  language: string[];
  addressLine1: string[];
  addressLine2: string[];
  city: string[];
  state: string[];
  zip: string[];
  address: string;
  country: string[];
  delivery_addressLine1: string[];
  delivery_addressLine2: string[];
  delivery_city: string[];
  delivery_state: string[];
  delivery_zip: string[];
  delivery_address: string;
  delivery_country: string[];
  provider: string[];
  referralPartner: string;
  eligibilityGroup: string;
  replaces: string;
  replacedBy: string;
}

const PatientCDO: PatientCDOModel = {
  org: '',
  id: '',
  firstName: [''],
  lastName: [''],
  middleName: [''],
  dob: '',
  age: 0,
  gender: '',
  genderPrefix: '',
  homePhone: [''],
  mobilePhone: [''],
  email: [''],
  memberId: [''],
  otherId: [''],
  personId: [''],
  language: [''],
  addressLine1: [''],
  addressLine2: [''],
  city: [''],
  state: [''],
  zip: [''],
  address: '',
  country: ['USA'],
  delivery_addressLine1: [''],
  delivery_addressLine2: [''],
  delivery_city: [''],
  delivery_state: [''],
  delivery_zip: [''],
  delivery_address: '',
  delivery_country: ['USA'],
  provider: [''],
  referralPartner: '',
  eligibilityGroup: '',
  replaces: '',
  replacedBy: '',
};
// TODO Check if the country USA is always the constant
export default PatientCDO;
